import { Button, Result } from 'antd';
import * as React from 'react';
import { Link } from 'react-router-dom';

function NotificationPage() {
    return (
      <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={<Link to="/"><Button type="primary">Back to Dashboard</Button></Link>}
        />
    );
}

export default NotificationPage;
